import type { ParsedUrlQuery } from 'querystring';
import { stringify } from 'querystring';

import type { TeamsMeeting, TeamsMeetingFeedParameters } from '@ms/yammer-data/dist/state/types';
import { basenameForTeamsMeetingApp } from '@ms/yammer-libs-url-path-support';

type TeamsMeetingPage = (teamsMeetingId: TeamsMeeting['id']) => string;
export const teamsMeetingPagePathname: TeamsMeetingPage = (teamsMeetingId) => `/teams-meeting/${teamsMeetingId}`;

export const teamsMeetingPageMyConversations: TeamsMeetingPage = (teamsMeetingId) =>
  `/teams-meeting/${teamsMeetingId}/my`;

export const teamsMeetingPageInReviewConversations: TeamsMeetingPage = (teamsMeetingId) =>
  `/teams-meeting/${teamsMeetingId}/in-review`;

export const teamsMeetingPageDismissedConversations: TeamsMeetingPage = (teamsMeetingId) =>
  `/teams-meeting/${teamsMeetingId}/dismissed`;

export const teamsMeetingPagePublishedConversations: TeamsMeetingPage = (teamsMeetingId) =>
  `/teams-meeting/${teamsMeetingId}/published`;

export const teamsMeetingPageQueuedQuestions: TeamsMeetingPage = (teamsMeetingId) =>
  `/teams-meeting/${teamsMeetingId}/queued-questions`;

type TeamsMeetingPagePublishedConversationsWithParams = (
  teamsMeetingId: TeamsMeeting['id'],
  feedParameters: TeamsMeetingFeedParameters
) => string;
export const teamsMeetingPagePublishedConversationsWithParams: TeamsMeetingPagePublishedConversationsWithParams = (
  teamsMeetingId,
  feedParameters
) =>
  `${teamsMeetingPagePublishedConversations(teamsMeetingId)}?${stringify(feedParameters as unknown as ParsedUrlQuery)}`;

type TeamsMeetingAppPage = (teamsMeetingId: TeamsMeeting['id']) => string;
export const teamsMeetingAppPage: TeamsMeetingAppPage = (teamsMeetingId) => {
  const host = `${location.protocol}//${location.host}${basenameForTeamsMeetingApp}`;

  return `${host}/teams-meeting/${teamsMeetingId}?client=teams`;
};

export const teamsMeetingPageMatchPath = '/teams-meeting/:teamsMeetingId';
